import React from "react";

/**
 * Avatar - User avatar component
 *
 * @param {Object} props
 * @param {string} props.src - Image source
 * @param {string} props.alt - Image alt text
 * @param {string} props.className - Additional CSS classes
 */
const Avatar = ({ src, alt = "User avatar", className = "", ...rest }) => {
  return (
    <img
      src={src}
      alt={alt}
      className={`h-8 w-8 rounded-full border-2 border-[--elita-secondary-hover] transition-colors duration-200 ${className}`}
      {...rest}
    />
  );
};

export default Avatar;
